module.exports = __webpack_public_path__ + "static/media/Alignment-red.bbc72560.svg";